module.exports = __webpack_public_path__ + "static/media/26.dfd7b3cf.png";